import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M-1.5,-2.5h0.5v1h-0.5zM-5,-1.5h0.5v0.5h-0.5zM-1.5,-1.5h1v0.5h-1zM-6,-1h2v0.5h-2zM-1.5,-1h4v0.5h-4zM-5.5,-0.5h8v0.5h-8zM5.5,-0.5h0.5v0.5h-0.5zM-4.5,0h7v0.5h-7zM-3.5,0.5h6.5v0.5h-6.5zM-2.5,1h5.5v0.5h-5.5zM-1.5,1.5h3.5v0.5h-3.5zM-1,2h2v0.5h-2z',
    },
    {
      paint: 'boulder',
      d: 'M-6,-0.5h0.5v0.5h-0.5zM6,-0.5h0.5v0.5h-0.5zM-6,0h1.5v0.5h-1.5zM5.5,0h1v0.5h-1zM-5.5,0.5h2v0.5h-2zM5,0.5h1v0.5h-1zM-4.5,1h2v0.5h-2zM3,1h2v0.5h-2zM-3.5,1.5h2v0.5h-2zM2,1.5h2v0.5h-2zM-2.5,2h1.5v0.5h-1.5zM1,2h2v0.5h-2zM-1.5,2.5h3.5v0.5h-3.5zM-0.5,3h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['barrel', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M-1,-7h0.5v0.5h-0.5zM-1,-6.5h1v0.5h-1zM-1,-6h2.5v0.5h-2.5zM-1.5,-5.5h3v0.5h-3zM-1.5,-5h1v2h-1zM0,-5h2v1h-2zM-2.5,-4.5h0.5v0.5h-0.5zM-4.5,-4h1.5v0.5h-1.5zM0,-4h2.5v2h-2.5zM-4.5,-3.5h0.5v0.5h-0.5zM-3.5,-3.5h1v0.5h-1zM-5,-3h1v0.5h-1zM-3.5,-3h1.5v0.5h-1.5zM-1,-3h0.5v1h-0.5zM-5,-2.5h0.5v0.5h-0.5zM-4,-2.5h2v0.5h-2zM-4.5,-2h0.5v1h-0.5zM-3.5,-2h1.5v1h-1.5zM-0.5,-2h3v0.5h-3zM3,-2h1.5v0.5h-1.5zM0,-1.5h2v0.5h-2zM2.5,-1.5h1.5v0.5h-1.5zM-4,-1h2v0.5h-2zM2.5,-1h0.5v0.5h-0.5zM3.5,-1h1v0.5h-1zM2.5,-0.5h2.5v0.5h-2.5zM2.5,0h0.5v0.5h-0.5zM3.5,0h1.5v0.5h-1.5zM3,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['barrel', 0.27],
        ['shadow', 0.3],
        ['trunk', 0.44],
      ],
      d: 'M2.5,-7h0.5v0.5h-0.5zM0,-6.5h3v0.5h-3zM1.5,-6h1.5v1h-1.5zM2,-5h1.5v1h-1.5zM-4.5,-4.5h0.5v0.5h-0.5zM-2,-4.5h0.5v0.5h-0.5zM-3,-4h1.5v0.5h-1.5zM2.5,-4h1v1.5h-1zM-2.5,-3.5h1v0.5h-1zM-2,-3h1v0.5h-1zM-2,-2.5h0.5v2h-0.5zM2.5,-2.5h0.5v1h-0.5zM-1,-2h0.5v0.5h-0.5zM4.5,-2h1v0.5h-1zM2,-1.5h0.5v0.5h-0.5zM4,-1.5h1.5v0.5h-1.5zM4.5,-1h1v0.5h-1zM5,-0.5h0.5v1h-0.5zM4.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['barrel', 0.28],
        ['sail', 0.27],
        ['trunk', 0.45],
      ],
      d: 'M0,-7.5h1.5v0.5h-1.5zM-0.5,-7h3v0.5h-3zM-4.5,-5h2.5v0.5h-2.5zM-0.5,-5h0.5v3h-0.5zM-4,-4.5h1.5v0.5h-1.5zM-4,-3.5h0.5v1h-0.5zM-4.5,-2.5h0.5v0.5h-0.5zM3,-2.5h2v0.5h-2zM-4,-2h0.5v1h-0.5zM-0.5,-1.5h0.5v0.5h-0.5zM3,-1h0.5v0.5h-0.5zM3,0h0.5v0.5h-0.5z',
    },
  ],
  pixels: 328,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M2.5,-2h0.5v1.5h-0.5zM-6,-1h1v0.5h-1zM-5.5,-0.5h1v0.5h-1zM-2.5,-0.5h0.5v0.5h-0.5zM2,-0.5h1v0.5h-1zM5.5,-0.5h0.5v0.5h-0.5zM-4.5,0h3v0.5h-3zM2,0h1.5v0.5h-1.5zM4.5,0h0.5v0.5h-0.5zM-3.5,0.5h7.5v0.5h-7.5zM-2.5,1h5.5v0.5h-5.5zM-1.5,1.5h3.5v0.5h-3.5zM-1,2h2v0.5h-2z',
    },
    {
      paint: 'boulder',
      d: 'M-6,-0.5h0.5v0.5h-0.5zM6,-0.5h0.5v0.5h-0.5zM-6,0h1.5v0.5h-1.5zM5,0h1.5v0.5h-1.5zM-5.5,0.5h2v0.5h-2zM4,0.5h2v0.5h-2zM-4.5,1h2v0.5h-2zM3,1h2v0.5h-2zM-3.5,1.5h2v0.5h-2zM2,1.5h2v0.5h-2zM-2.5,2h1.5v0.5h-1.5zM1,2h2v0.5h-2zM-1.5,2.5h3.5v0.5h-3.5zM-0.5,3h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['barrel', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M-2,-5.5h0.5v0.5h-0.5zM-1,-5.5h2v0.5h-2zM-2,-5h2.5v1h-2.5zM-5,-4.5h1v0.5h-1zM-5.5,-4h2.5v1h-2.5zM-2,-4h3v0.5h-3zM-2,-3.5h0.5v3h-0.5zM-1,-3.5h2v0.5h-2zM-5.5,-3h0.5v2h-0.5zM-4.5,-3h2v2h-2zM-1,-3h2.5v2.5h-2.5zM4.5,-2.5h0.5v0.5h-0.5zM3,-2h1v0.5h-1zM3.5,-1.5h1v0.5h-1zM-5,-1h2.5v0.5h-2.5zM3.5,-1h1.5v0.5h-1.5zM-4.5,-0.5h1.5v0.5h-1.5zM-1.5,-0.5h3v0.5h-3zM3,-0.5h2v0.5h-2zM-1,0h2.5v0.5h-2.5z',
    },
    {
      paint: [
        ['barrel', 0.27],
        ['shadow', 0.3],
        ['trunk', 0.44],
      ],
      d: 'M1.5,-6h0.5v0.5h-0.5zM-1.5,-5.5h0.5v0.5h-0.5zM1,-5.5h1v0.5h-1zM-2.5,-5h0.5v0.5h-0.5zM0.5,-5h1.5v0.5h-1.5zM-4,-4.5h2v0.5h-2zM0.5,-4.5h2v0.5h-2zM-3,-4h1v1h-1zM1,-4h1.5v1h-1.5zM-2.5,-3h0.5v2.5h-0.5zM1.5,-3h1v2.5h-1zM5,-2.5h0.5v0.5h-0.5zM4,-2h1.5v0.5h-1.5zM4.5,-1.5h1v0.5h-1zM5,-1h0.5v1h-0.5zM-3,-0.5h0.5v0.5h-0.5zM-2,-0.5h0.5v0.5h-0.5zM1.5,-0.5h0.5v1h-0.5zM-1.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['barrel', 0.28],
        ['sail', 0.27],
        ['trunk', 0.45],
      ],
      d: 'M-1.5,-6h3v0.5h-3zM-4.5,-5.5h2v0.5h-2zM-5,-5h2.5v0.5h-2.5zM-1.5,-3.5h0.5v3h-0.5zM-5,-3h0.5v2h-0.5zM3,-3h2v0.5h-2zM3,-2.5h1.5v0.5h-1.5zM3,-1.5h0.5v1h-0.5zM3.5,0h1v0.5h-1z',
    },
  ],
  pixels: 316,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M-2.5,-2h1v0.5h-1zM1.5,-2h0.5v1h-0.5zM-2.5,-1.5h1.5v0.5h-1.5zM-6,-1h5v0.5h-5zM2,-1h0.5v0.5h-0.5zM4.5,-1h1v0.5h-1zM-5.5,-0.5h4.5v0.5h-4.5zM2,-0.5h4v0.5h-4zM-4.5,0h3.5v0.5h-3.5zM2,0h3v0.5h-3zM-3.5,0.5h2.5v0.5h-2.5zM2,0.5h2v0.5h-2zM-2.5,1h2v0.5h-2zM1.5,1h1.5v0.5h-1.5zM-1.5,1.5h3.5v0.5h-3.5zM-1,2h2v0.5h-2z',
    },
    {
      paint: 'boulder',
      d: 'M-6,-0.5h0.5v0.5h-0.5zM6,-0.5h0.5v0.5h-0.5zM-6,0h1.5v0.5h-1.5zM5,0h1.5v0.5h-1.5zM-5.5,0.5h2v0.5h-2zM4,0.5h2v0.5h-2zM-4.5,1h2v0.5h-2zM3,1h2v0.5h-2zM-3.5,1.5h2v0.5h-2zM2,1.5h2v0.5h-2zM-2.5,2h1.5v0.5h-1.5zM1,2h2v0.5h-2zM-1.5,2.5h3.5v0.5h-3.5zM-0.5,3h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['barrel', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M-2,-6.5h0.5v0.5h-0.5zM4.5,-6.5h0.5v0.5h-0.5zM-2,-6h1.5v0.5h-1.5zM2.5,-6h1.5v0.5h-1.5zM-2,-5.5h2v0.5h-2zM1.5,-5.5h2v0.5h-2zM-3,-5h0.5v0.5h-0.5zM-2,-5h0.5v2.5h-0.5zM-1,-5h1.5v1h-1.5zM1.5,-5h2.5v0.5h-2.5zM-4.5,-4.5h1.5v0.5h-1.5zM1.5,-4.5h1v0.5h-1zM3,-4.5h1.5v0.5h-1.5zM-5.5,-4h2v0.5h-2zM-1,-4h2v2h-2zM1.5,-4h0.5v1.5h-0.5zM2.5,-4h2v2h-2zM-5.5,-3.5h0.5v1.5h-0.5zM-4.5,-3.5h1.5v1.5h-1.5zM-5.5,-2h2.5v0.5h-2.5zM-1,-2h0.5v0.5h-0.5zM2,-2h2.5v1h-2.5zM-5,-1.5h2v0.5h-2zM-0.5,-1.5h1.5v0.5h-1.5zM-1,-1h1.5v0.5h-1.5zM-1,-0.5h0.5v0.5h-0.5zM0,-0.5h1v0.5h-1zM-1,0h2.5v1h-2.5zM0,1h1v0.5h-1z',
    },
    {
      paint: [
        ['barrel', 0.27],
        ['shadow', 0.3],
        ['trunk', 0.44],
      ],
      d: 'M1,-6.5h0.5v0.5h-0.5zM-0.5,-6h2v0.5h-2zM2,-6h0.5v0.5h-0.5zM4,-6h1v0.5h-1zM0,-5.5h1.5v0.5h-1.5zM3.5,-5.5h2v0.5h-2zM0.5,-5h1v1h-1zM4,-5h1.5v0.5h-1.5zM-5,-4.5h0.5v0.5h-0.5zM-3,-4.5h0.5v0.5h-0.5zM4.5,-4.5h1v3.5h-1zM-3.5,-4h1v0.5h-1zM1,-4h0.5v2h-0.5zM-3,-3.5h1v1.5h-1zM-3,-2h0.5v1h-0.5zM-1.5,-2h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5zM1,-1.5h0.5v0.5h-0.5zM0.5,-1h1.5v0.5h-1.5zM2.5,-1h2v0.5h-2zM1,-0.5h1v0.5h-1zM1.5,0h0.5v1h-0.5zM-0.5,1h0.5v0.5h-0.5zM1,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['barrel', 0.28],
        ['sail', 0.27],
        ['trunk', 0.45],
      ],
      d: 'M-1.5,-7h2.5v1h-2.5zM2,-6.5h2.5v0.5h-2.5zM-5,-5h2v0.5h-2zM-1.5,-5h0.5v2.5h-0.5zM2.5,-4.5h0.5v0.5h-0.5zM2,-4h0.5v1.5h-0.5zM-5,-3.5h0.5v1.5h-0.5zM-2,-2.5h1v0.5h-1zM1.5,-2.5h1v0.5h-1zM-0.5,-2h2v0.5h-2zM-0.5,-0.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 367,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
